<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="isLoading"
  [isDisabled]="isLoading || !canSend">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>


<ng-template #content>
  <div mat-dialog-content>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
        <div class="form-group row">
          <mat-form-field class="">
            <mat-label>Message</mat-label>
            <textarea matInput placeholder="" formControlName="message"></textarea>
            <mat-error>
              <span *ngIf="f('message').hasError('required')">Veuillez saisir un message</span>
              <span *ngIf="f('message').hasError('maxLength')">Votre message est trop long</span>
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
</ng-template>